import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined, ArrowLeftOutlined, ReloadOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import OutstandingPdcTable from "./components/OutstandingPdcTable";
import ReportDom from "../../../components/common/ReportDom";
import { fetchOutstandingPdc } from "./outstandingPdcThunk";

const { Title } = Typography;

const OutstandingPdc = () => {
  const dispatch = useDispatch();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.outstandingPdc);

  useEffect(() => {
    dispatch(fetchOutstandingPdc());
  }, [dispatch]);

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const reportRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Daily Cash Flow Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
                Daily Cash Flow
              </Title>
            </div>
          }
          extra={
            <Flex gap={8}>
              <Button
                icon={<ReloadOutlined />}
                loading={loading}
                onClick={() => dispatch(fetchOutstandingPdc())}
              >
                {!screens.xs && "Refresh"}
              </Button>
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <Card className="shadow-md rounded-xl">
          <OutstandingPdcTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Daily Cash Flow"
          mode="report-page"
          renderTable={() => <OutstandingPdcTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default OutstandingPdc;
